<div class="tab-content">
  <div class="tab-header-row">
    <h2>Customer Payments</h2>
    <button mat-button class="btn-bg-green" [disabled]="!canEdit" (click)="openPaymentForm()">+ Add Payment</button>
  </div>

  @if (Loading) {
    <p class="loading-text">Loading customer payments...</p>
  } @else if (Payments.length === 0) {
    <div class="empty-state">
      <mat-icon>payments</mat-icon>
      <p class="empty-title">No Payments Found</p>
      <p class="empty-message">No payment activity has been recorded for this customer yet.</p>
      <button mat-button class="btn-bg-green" [disabled]="!canEdit" (click)="openPaymentForm()">Create First Payment</button>
    </div>
  } @else {
    <div class="stat-cards">
      <div class="stat-card stat-total">
        <div class="stat-value">{{ totalPayments | currency }}</div>
        <div class="stat-label">Total Recorded</div>
      </div>
      <div class="stat-card stat-authorized">
        <div class="stat-value">{{ authorizedAmount | currency }}</div>
        <div class="stat-label">Authorized Amount</div>
      </div>
      <div class="stat-card stat-settled">
        <div class="stat-value">{{ settledAmount | currency }}</div>
        <div class="stat-label">Settled Amount</div>
      </div>
      <div class="stat-card stat-outstanding">
        <div class="stat-value">{{ outstandingBalance | currency }}</div>
        <div class="stat-label">Outstanding Balance</div>
      </div>
    </div>

    <rms-table
      [data]="Payments"
      [columns]="Columns"
      [icons]="Icons"
      [parentContext]="this"
      [clickableRow]="canEdit"
      (onRowClick)="addPaymentForOrder($event.row)"
      startSort="CreatedDate"
      startSortDirection="desc"
      tableId="customer-payments-tab">
    </rms-table>
  }
</div>
